import {
  useGetBlockByDistrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";
import { useGetFarmersQuery } from "features/onboarding/users/farmer/farmerApiSlice";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "@mui/material";
import { Tag } from "antd";
import { setBreadcrumbs } from "app/appSlice";
import CustomSearchBar from "components/CustomSearchBar";
import ListViewActionItems from "components/ListViewActionItems";
import ListViewContainer from "components/ListViewContainer";
import { selectCurrentUser } from "features/auth/authSlice";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, CardHeader } from "reactstrap";
import ProjectMap from "features/dashboard/Project/ProjectMap";
import { useGetSaathiFLEQuery } from "features/CrmDashboardComp/CmrApiSlice";
import { useGetCropListQuery } from "features/dashboard/RiskManagement/RiskManagementApiSlice";
import SortDropdown from "features/onboarding/users/farmer/SortDropdown";
import { ProjectCharts } from "features/dashboard/Project/ProjectCharts";
import { ProjectSideAnalytics } from "features/dashboard/Project/ProjectSideAnalytics";
import { useGetFPOListQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { DateRangePicker } from "rsuite";
import LocationFilter from "./LocationFilters";
import { useTranslation } from "react-i18next";

const HclProjectFarmerNewComponent = ({
  showMap = true,
  setGeojsonInParent = () => {},
  projectExist,
  firstState,
  firstDistrict,
  firstStateCode,
  firstDistrictCode,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const noSidebar = location?.pathname?.includes("project");
  const orgId = id ? id : "";
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [farmers, setFarmers] = useState([]);
  const [showGeojson, setGeojsonData] = useState();
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    per_page: 50,
  });
  const [comingState, setComingState] = useState("");
  const [comingStateId, setComingStateId] = useState("");
  const [comingDistrict, setcomingDistrict] = useState("");
  const [comingDistrictId, setcomingDistrictId] = useState("");
  const [stateName, setStateName] = useState(firstState ? comingState : "");
  const { t, i18n } = useTranslation();

  const [stateId, setStateId] = useState(firstStateCode ? comingStateId : "");
  // const [stateId, setStateId] = useState(firstStateCode?"9":"null");
  const [districtName, setDistrictName] = useState(
    firstDistrict ? comingDistrict : ""
  );

  const [districtId, setDistrictId] = useState(
    firstDistrictCode ? comingDistrictId : ""
  );
  const [blockId, setBlockId] = useState("null");

  const [searchKey, setSearchKey] = useState("");
  // const [activeCard, setActiveCard] = useState("FarmerLeads");
  const [activeCard, setActiveCard] = useState("Farmers");
  // const [acs, setACS] = useState("");
  const [gender, setGender] = useState("");
  const [farmerCategory, setFarmerCategory] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [SelectedFle, setSelectedFle] = useState("");
  const [selectedFpo, setselectedFpo] = useState("");
  const [selectedCrops, setSelectedCrops] = useState([]);
  const [cropQueryString, setcropQueryString] = useState("");
  const [SortField, setSortField] = useState("");
  const [SortType, setSortType] = useState("");
  const [range, setRange] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [filters, setFilters] = useState({
    district: null,
    block: null,
    grampanchayat: null,
    majra: null,
  });

  const handleLocationChange = (newFilters) => {
    setFilters(newFilters);
  };

  const { data: data, isLoading, isFetching, refetch } = useGetFarmersQuery(
    {
      orgId,
      page: pagination.page,
      per_page: pagination.per_page,
      stateName,
      districtName: filters?.district?.value,
      blockName: filters?.block?.value,
      searchKey: debouncedSearch || "",
      farmerCategory,
      gender,
      SelectedFle,
      cropQueryString,
      SortField,
      SortType,
      selectedFpo,
      range,
    },
    { refetchOnMountOrArgChange: true, pollingInterval: 900000 }
  );

  const { data: FleList } = useGetSaathiFLEQuery(
    { districtId: "", searchKey: "" },
    { refetchOnMountOrArgChange: true }
  );
  const { data: Fpolist } = useGetFPOListQuery(
    { pagination: "", searchKey: "", orgId },
    { refetchOnMountOrArgChange: true }
  );

  const { data: getStates } = useGetStatesQuery();

  const canCall = { stateId: stateId, districtId: districtId };
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !canCall.stateId,
  });
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId, {
    skip: !canCall.districtId,
  });
  const { data: cropList } = useGetCropListQuery();

  // console.log("dataDistrict",dataDistrict)

  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  // const [stateName, setStateName] = useState(firstState?"Uttar Pradesh":"");

  const [blockName, setBlockName] = useState("");
  const [FleData, setFleList] = useState([]);
  const [FpoList, setFpoList] = useState([]);

  const columns = [
    { field: "full_name", headerName: t("Name"), width: 150 },

    {
      field: "created_at",
      headerName: t("Onboarding Date"),
      width: 150,
      renderCell: (cellvalues) => (
        <div>
          {cellvalues.row.created_at
            ? cellvalues.row.created_at.slice(0, 10)
            : ""}
        </div>
      ),
    },

    { field: "phone_number", headerName: t("Mobile"), width: 120 },
    { field: "gender", headerName: t("Gender"), width: 80 },

    {
      field: "age",
      headerName: t("Age"),
      width: 50,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "farmer_category",
      headerName: t("Category"),
      width: 200,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            fontSize: "14px",
          }}
          title={cellValues?.row?.farmer_category || ""}
        >
          {(cellValues?.row?.farmer_category || "").length > 50
            ? `${cellValues?.row?.farmer_category.substring(0, 50)}...`
            : cellValues?.row?.farmer_category || ""}
        </div>
      ),
    },

    {
      field: "total_land_holding",
      headerName: t("Calculated Landholding"),
      width: 110,
      renderCell: (cellvalues) => (
        <div>
          {cellvalues.row.calculated_land_holding} &nbsp;
          {cellvalues.row.unit_of_land_holding}
        </div>
      ),
    },

    {
      field: "total_acs",
      headerName:
        RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV")
          ? t("Farm Score")
          : t("ACS"),
      width: 100,
      renderCell: (cellvalues) => (
        <div>{cellvalues.row.total_acs.toFixed(2)}</div>
      ),
    },

    { field: "state_name", headerName: t("State Name"), width: 130 },

    {
      field: "district_name",
      headerName: t("District Name"),
      width: 140,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "140px",
            fontSize: "13px",
          }}
          title={cellValues?.row?.district_name || ""}
        >
          {(cellValues?.row?.district_name || "").length > 50
            ? `${cellValues?.row?.district_name.substring(0, 50)}...`
            : cellValues?.row?.district_name || ""}
        </div>
      ),
    },

    {
      field: "action",
      headerName: t("Action"),
      width: 60,
      renderCell: (cellvalues) => (
        <>
          <FontAwesomeIcon
            icon={faPenToSquare}
            className="mx-2"
            style={{ color: "orange", fontSize: "16px", cursor: "pointer" }}
            onClick={() => {
             
                 navigate(`/farmerDetail/onboarding/${cellvalues.row.id}`, {
                    replace: true,
                    state: {
                      fullname: cellvalues.row.full_name,
                    },
                  })
              
            }}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    if (data != undefined) {
      // const ApiData = data?.data?.results ? data?.data?.results : [];
      const GeojsonData = data?.data?.geojson ? data?.data?.geojson : null;
      const paginationFromApi = data?.data?.pages
        ? {
            page: data?.data?.current_page,
            pageCount: data?.data?.pages,
            per_page: data?.data?.per_page,
          }
        : pagination;
      setFarmers(data?.data?.results);
      setPagination(paginationFromApi);
      setGeojsonData(GeojsonData);
      setGeojsonInParent(GeojsonData);
    }
  }, [data]);
  useEffect(() => {
    if (FleList != undefined) {
      setFleList(FleList?.data?.results);
    }
    if (Fpolist != undefined) {
      setFpoList(Fpolist?.data?.results);
    }
  }, [FleList, Fpolist]);
  useEffect(() => {
    const matchedState = stateList?.find(
      (state) => state?.state_name?.toLowerCase() === firstState?.toLowerCase()
    );
    if (matchedState) {
      const stateName = matchedState.state_name;
      const stateCode = matchedState.state_code;
      setComingState(stateName);
      setComingStateId(stateCode);
      setStateName(stateName);
      setStateId(stateCode);
    }
  }, [stateList]);
  useEffect(() => {
    const matchedDistrict = districtList?.find(
      (district) =>
        district?.district_name?.toLowerCase() === firstDistrict?.toLowerCase()
    );
    if (matchedDistrict) {
      const stateName = matchedDistrict.district_name;
      const stateCode = matchedDistrict.district_code;
      setcomingDistrict(stateName);
      setcomingDistrictId(stateCode);
      setDistrictName(stateName);
      setDistrictId(stateCode);
    }
  }, [districtList]);
  const optionCrop = [
    {
      label: "Crop",
      options: cropList?.data?.results?.map((crop) => ({
        label: `${crop.crop_name}`,
        value: `${crop.crop_name}`,
      })),
    },
  ];
  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, page: value }));
    // setFarmers(value);
  };

  const pathName = window.location.pathname.split("/");
  const moduleName = pathName[pathName.length - 1];
  const moduleNameFromgPath =
    moduleName.charAt(0).toUpperCase() + moduleName.slice(1);
  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: moduleNameFromgPath },
    ];

    dispatch(setBreadcrumbs(breadcrumbs));
  }, []);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "35px",
      height: "35px",
      padding: "0px",
      fontSize: "13px",
      zIndex: 100,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };
  useEffect(() => {
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const onLocationChange = (event) => {
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
    if (event.ConditionName == "state") {
      setBlockId("null");
      setDistrictName("");
      setDistrictId("null");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("null");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };
  useEffect(() => {
    if (stateId !== "" || districtId !== "" || blockId !== "") {
      refetch();
    }
  }, [stateId, districtId, blockId]);
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (message) => {
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
    setSearchKey(message);
  };

  const [season, setSeason] = useState("Kharif");
  const [chartData, setChartData] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedAlias, setSelectedAlias] = useState(null);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleDateChange = (value) => {
    // console.log("Selected Date Range:", value);
    setDateValue(value);

    if (value) {
      const formattedRange = `${formatDate(value[0])},${formatDate(value[1])}`;
      // console.log("formattedRange", formattedRange);
      setRange(formattedRange);
    } else {
      setRange(null);
    }
  };
  const isProjectMaati =
    projectExist?.project_name ===
    "Project MAATI - Baseline Assessment of Value Chain";
  return (
    <>
      {showMap && projectExist && (
        <div className="row">
          <div
            className={
              projectExist?.analytics?.analytics ? "col-lg-9" : "col-lg-12"
            }
          >
            <Card className="" style={{ height: "60svh" }}>
              <CardBody className="p-1 p-lg-3">
                <ProjectMap
                  showGeojson={showGeojson}
                  projectExist={projectExist}
                  type={selectedIndex}
                  data={chartData}
                  season={season}
                  setSelectedAlias={setSelectedAlias}
                  selectedAlias={selectedAlias}
                />
              </CardBody>
            </Card>
          </div>
          {projectExist?.analytics?.analytics && (
            <div className="col-lg-3">
              <ProjectSideAnalytics
                projectExist={projectExist}
                setChartData={setChartData}
                chartData={chartData}
                setSelectedIndex={setSelectedIndex}
                selectedIndex={selectedIndex}
                setSelectedAlias={setSelectedAlias}
                selectedAlias={selectedAlias}
              />
              <></>
            </div>
          )}
          {chartData && selectedIndex && (
            <div className="col-lg-12">
              <div className="mt-3">
                <ProjectCharts type={selectedIndex} data={chartData} />
              </div>
            </div>
          )}
        </div>
      )}
      {!showMap && (
        <div>
          <>
            {activeCard === "Farmers" ? (
              <div className="transparent_card">
                <CardBody className="p-0 p-lg-3 ">
                  <div className="">
                    <>
                      <Row className="mt-1 px-lg-1 mb-2">
                        <Col
                          xs="6"
                          md="6"
                          lg="2"
                          className="d-flex justify-content-start"
                        >
                          <CustomSearchBar
                            sendSearchFunction={handleChangeSearch}
                          />
                        </Col>

                        <Col xs="6" md="6" lg="2" className="mb-lg-0 mb-2">
                          {!isProjectMaati && (
                            <div className="mt-2 d-flex justify-content-end">
                              {" "}
                              {t("Total Farmers")} :
                              <span className="text-success">
                                &nbsp;{data?.data?.total}
                              </span>
                            </div>
                          )}
                        </Col>
                        <Col
                          xs="12"
                          md="6"
                          lg="8"
                          className="d-flex flex-lg-row flex-column justify-content-end flex-wrap mt-lg-0 mt-3"
                        >
                          <ListViewActionItems
                            orgId={orgId}
                            refetch={refetch}
                            RoleAcessParams={RoleAcessParams}
                            currentUser={currentUser}
                            farmers={farmers}
                            stateId={stateId}
                            districtId={districtId}
                            blockId={blockId}
                            searchKey={searchKey}
                            farmerCategory={farmerCategory}
                            gender={gender}
                            setPagination={setPagination}
                            showFields={true}
                            SelectedFle={SelectedFle}
                            cropQueryString={cropQueryString}
                            selectedFpo={selectedFpo}
                            range={range}
                            SortField={SortField}
                            SortType={SortType}
                          />
                        </Col>
                      </Row>
                      <CardHeader>
                        <Row className="mt-3 align-items-center">
                          <Col lg="6">
                            <LocationFilter
                              onChange={handleLocationChange}
                              majraRequired={false}
                              GpRequired={false}
                              width={6}
                              firstDistrict={firstDistrict}
                            />
                          </Col>

                          <Col sm="2" className="mb-2 position-relative">
                            {/* <Select
                              menuPlacement="auto"
                              options={[
                                { value: "Male", label: "Male" },
                                { value: "Female", label: "Female" },
                                { value: "Others", label: "Others" },
                              ]}
                              placeholder={gender === "" ? "Gender" : gender}
                              value={gender === "" ? "Gender" : gender}
                              onChange={(selected) => {
                                setGender(selected?.value || null);
                                setPagination({
                                  page: 1,
                                  pageCount: 0,
                                  per_page: 50,
                                });
                              }}
                              styles={customStyles}
                            /> */}
                            <Select
                              menuPlacement="auto"
                              options={[
                                { value: "Male", label: t("Male") },
                                { value: "Female", label: t("Female") },
                                { value: "Others", label: t("Others") },
                              ]}
                              placeholder={
                                gender === "" ? t("Gender") : t(gender)
                              }
                              value={
                                gender
                                  ? { label: t(gender), value: gender }
                                  : null
                              }
                              onChange={(selected) => {
                                setGender(selected?.value || null);
                                setPagination({
                                  page: 1,
                                  pageCount: 0,
                                  per_page: 50,
                                });
                              }}
                              styles={customStyles}
                            />

                            {gender && (
                              <span
                                className="clear-icon"
                                onClick={() => setGender("")}
                                style={{
                                  position: "absolute",
                                  top: "60%",
                                  right: "60px",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "gray",
                                  fontSize: "12px",
                                  zIndex: 1000,
                                }}
                              >
                                ✕
                              </span>
                            )}
                          </Col>
                          <Col
                            sm="3"
                            xs="10"
                            className="mb-2 position-relative"
                          >
                            {/* <Select
                              menuPlacement="auto"
                              options={[
                                {
                                  value: "Marginal (Less than 2.5 acres)",
                                  label: "Marginal (Less than 2.5 acres)",
                                },
                                {
                                  value: "Small (2.5–5 acres)",
                                  label: "Small (2.5–5 acres)",
                                },
                                {
                                  value: "Semi Medium (5–10 acres)",
                                  label: "Semi Medium (5–10 acres)",
                                },
                                {
                                  value: "Medium (10–25 acres)",
                                  label: "Medium (10–25 acres)",
                                },
                                {
                                  value: "Large (25 acres and above)",
                                  label: "Large (25 acres and above)",
                                },
                              ]}
                              placeholder={
                                farmerCategory === ""
                                  ? "Category"
                                  : farmerCategory
                              }
                              value={
                                farmerCategory === ""
                                  ? "Category"
                                  : farmerCategory
                              }
                              onChange={(selected) => {
                                setFarmerCategory(selected?.value || null);
                                setPagination({
                                  page: 1,
                                  pageCount: 0,
                                  per_page: 50,
                                });
                              }}
                              styles={customStyles}
                            /> */}
                            <Select
                              menuPlacement="auto"
                              options={[
                                {
                                  value: "Marginal (Less than 2.5 acres)",
                                  label: t("Marginal (Less than 2.5 acres)"),
                                },
                                {
                                  value: "Small (2.5–5 acres)",
                                  label: t("Small (2.5–5 acres)"),
                                },
                                {
                                  value: "Semi Medium (5–10 acres)",
                                  label: t("Semi Medium (5–10 acres)"),
                                },
                                {
                                  value: "Medium (10–25 acres)",
                                  label: t("Medium (10–25 acres)"),
                                },
                                {
                                  value: "Large (25 acres and above)",
                                  label: t("Large (25 acres and above)"),
                                },
                              ]}
                              placeholder={
                                farmerCategory === ""
                                  ? t("Category")
                                  : t(farmerCategory)
                              }
                              value={
                                farmerCategory
                                  ? {
                                      label: t(farmerCategory),
                                      value: farmerCategory,
                                    }
                                  : null
                              }
                              onChange={(selected) => {
                                setFarmerCategory(selected?.value || null); // VALUE stays English
                                setPagination({
                                  page: 1,
                                  pageCount: 0,
                                  per_page: 50,
                                });
                              }}
                              styles={customStyles}
                            />

                            {farmerCategory && (
                              <span
                                className="clear-icon"
                                onClick={() => setFarmerCategory("")}
                                style={{
                                  position: "absolute",
                                  top: "60%",
                                  right: "60px",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "gray",
                                  fontSize: "12px",
                                  zIndex: 1000,
                                }}
                              >
                                ✕
                              </span>
                            )}
                          </Col>

                          <Col sm="1" xs="2" className="mb-2 position-relative">
                            <SortDropdown
                              onSortChange={({ field, direction }) => {
                                setSortField(field);
                                setSortType(direction);
                              }}
                            />
                          </Col>

                          <Col lg="3">
                            <DateRangePicker
                              className="mt-1 custom-date-picker"
                              size="md"
                              style={{
                                display: "block",
                                position: "relative",
                              }}
                              value={dateValue}
                              onChange={handleDateChange}
                              placeholder="Select date range"
                              cleanable
                            />
                          </Col>
                        </Row>
                      </CardHeader>
                    </>
                  </div>
                  <div>
                    <div className=" py-3 d-lg-none d-md-none d-block">
                      <div className="d-flex flex-lg-row flex-md-row flex-wrap  d-lg-none d-md-block d-block">
                        {isLoading || isFetching ? (
                          <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                            <h5>Loading...</h5>
                          </div>
                        ) : farmers.length > 0 ? (
                          farmers.map((farmer) => (
                            <div
                              className="card mb-3 col-lg-3 col-md-6 col-12 shadow-sm rounded-3 custom-hover-effect"
                              key={farmer.id}
                            >
                              <div className="card-body p-3 fpo_card position-relative">
                                <div
                                  className="d-flex align-items-center py-2 gap-3"
                                  style={{
                                    borderBottom: "1px solid #ebeaeab5",
                                  }}
                                >
                                  <div>
                                    <h5 className="text-success m-0 text-capitalize">
                                      {farmer?.full_name || "N/A"}
                                    </h5>
                                    <div className="d-flex">
                                      <h6 style={{ color: "#5c5c5cb3" }}>
                                        {farmer.primary_occupation}
                                      </h6>
                                    </div>
                                  </div>
                                  <button
                                    className="btn btn-outline-primary position-absolute"
                                    style={{ right: "4%", top: "10%" }}
                                    onClick={() => {
                                      navigate(
                                        `/onboarding/farmers/${farmer.id}`,
                                        {
                                          state: { fullname: farmer.full_name },
                                        }
                                      );
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-1">
                                  <span className="card-text d-flex gap-1 mt-1">
                                    <i className="mdi mdi-phone text-warning me-2 fs-6"></i>
                                    <h6>Phone:</h6>{" "}
                                    {farmer?.phone_number || "N/A"}
                                  </span>
                                  <span className="card-text d-flex gap-1 mt-1">
                                    <i className="mdi mdi-gender-male-female text-secondary me-2 fs-6"></i>
                                    <h6>Gender:</h6> {farmer?.gender || "N/A"}
                                  </span>
                                </div>

                                <span className="card-text d-flex gap-1 mt-1">
                                  <i className="mdi mdi-calendar-clock text-info me-2 fs-6"></i>
                                  <h6>Joined:</h6>{" "}
                                  {farmer.created_at
                                    ? farmer.created_at.slice(0, 10)
                                    : "N/A"}
                                </span>
                                <span className="card-text d-flex gap-1 mt-1">
                                  <i className="mdi mdi-map-marker text-danger me-2 fs-6"></i>
                                  {farmer?.address || "N/A"}
                                </span>

                                <div className="d-flex justify-content-between align-items-center mt-2">
                                  <span className="card-text d-flex gap-1">
                                    <i className="mdi mdi-information text-success me-2 fs-6"></i>
                                    <h6>Status:</h6>{" "}
                                    <Tag
                                      bordered={false}
                                      style={{ fontWeight: "500" }}
                                      color="geekblue"
                                    >
                                      {farmer.current_status
                                        .replaceAll("_", " ")
                                        .slice(0, 30)}
                                      {farmer.current_status.length > 30
                                        ? "..."
                                        : ""}
                                    </Tag>
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                            <h5>No Data Available</h5>
                          </div>
                        )}
                      </div>
                      <Pagination
                        count={pagination.pageCount}
                        page={pagination.page}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded"
                      />
                    </div>
                    <div className="d-lg-block d-md-block d-none">
                      <ListViewContainer
                        showHeaderSection={true}
                        searchBar={true}
                        tableData={{
                          rows: farmers,
                          columns: columns,
                          paginationState: [pagination, setPagination],
                          isLoading: isLoading || isFetching,
                          checkboxShowFalse: true,
                        }}
                      />
                    </div>
                  </div>
                </CardBody>
              </div>
            ) : (
              ""
            )}
          </>
        </div>
      )}
    </>
  );
};
export default HclProjectFarmerNewComponent;
